import { useFormik } from "formik";
import { useState } from "react";
import { editProcData } from "../../../API/store/actions/procedure/procedure";
import DateInput from "../../sharedComponents/datesInputs/date";
import TextArea from "../../sharedComponents/textarea/textArea";
import {
  formikSetup,
  formikValidation,
  initialValues,
  validationSchema,
} from "../formikValidation";
import Lang from "../../../userPreferences/staticWords";
import Button from "../../sharedComponents/buttons/button";
import { useDispatch } from "react-redux";
import * as actionTypes from "../../../API/store/actions/actionTypes";
import { englishDate } from "../../../algorithms";

const EditProcForm = ({
  userToken,
  setVisible,
  procId,
  SUbTaskId,
  procData,
  setProcAdded,
  procAdded,
  isActivityProc,
  activityId,
  projectStatusId,
}) => {
  const [validDate, setValidDate] = useState(true);
  const [errorMessage, setErrorMessage] = useState(false);
  const dispatch = useDispatch();
  const [disable, setDisable] = useState(false);

  const submit = async (values) => {
    let formData = new FormData();
    const newData = {
      Id: parseInt(procId),
      Description: values.Description,
      StartDate: englishDate(values.StartDate) + "T00:00:00",
      // EndDate: englishDate(values.EndDate) + "T00:00:00",
      MemberId: values.UserId ?? null,
      TaskId: procData.data.taskId,
      SUbTaskId: SUbTaskId,
      //members: {},
    };

    if (!SUbTaskId) {
      delete newData.SUbTaskId;
    }

    for (let [key, value] of Object.entries(newData)) {
      formData.append(key, value);
    }

    if (validDate) {
      let res = await editProcData(formData, isActivityProc, userToken);
      if (res.status <= 206) {
        dispatch({ type: actionTypes.RELOAD });
        setProcAdded(!procAdded);
        resetForm();
        setVisible(false);
        setDisable(false);
      } else if (res.status == 1000) {
        setErrorMessage(true);
        setDisable(true);
      }
    }
  };

  const formik = useFormik(
    formikSetup(
      initialValues,
      { Id: parseInt(procId), ...procData.data },
      validationSchema,
      "editProc",
      submit
    )
  );
  const {
    errors,
    touched,
    handleSubmit,
    handleChange,
    setFieldValue,
    values,
    resetForm,
    setFieldTouched,
  } = formik;

  return (
    <form id="addProcedure" onSubmit={handleSubmit}>
      <div className="d-flex flex-wrap justify-content-around">
        <TextArea
          name={"Description"}
          value={values.Description}
          onChange={handleChange}
          errorMessage={formikValidation(touched, errors, "Description")}
          placeholder={Lang.Description + "*"}
          containerStyle={"col-10 mt-4"}
          rows={4}
        ></TextArea>
        {/* <div className="col-10 d-flex flex-md-row flex-column mt-4">
          <DateInput
            errorMessage={formikValidation(touched, errors, "StartDate")}
            placeholder={Lang.startDate + "*"}
            containerStyle={"col-12 col-md-6 ps-2"}
            name={"StartDate"}
            onChange={(e) => {
              setFieldValue("StartDate", e);
              if (values.EndDate)
                if (new Date(values.EndDate) >= new Date(e)) setValidDate(true);
                else setValidDate(false);
            }}
            value={values.StartDate}
          />
          <DateInput
            errorMessage={formikValidation(touched, errors, "EndDate")}
            placeholder={Lang.endDate + "*"}
            containerStyle={"col-12 col-md-6 pe-2"}
            name={"EndDate"}
            value={values.EndDate}
            onChange={(e) => {
              setFieldValue("EndDate", e);
              if (values.StartDate)
                if (new Date(values.StartDate) <= new Date(e))
                  setValidDate(true);
                else setValidDate(false);
            }}
          />
        </div> 

        {!validDate &&
        values.EndDate.split("T")[0] &&
        values.StartDate.split("T")[0] ? (
          <div className="col-10 my-1 text-danger px-2">{Lang.invalidDate}</div>
        ) : null}
*/}
        {/* <DropDownList
          containerStyle={"col-10 my-2"}
          placeholder={"اختر مستخدم*"}
          value={values.UserId}
          dataSource={procData.data.members}
          field={{ value: "memberId", text: "memberName" }}
          change={(e) => {
            setFieldValue("UserId", e.value);
          }}
        /> */}

        {errorMessage ? (
          <div className="d-flex justify-content-center col-12 mt-3">
            <p style={{ color: "red", fontWeight: "bold", fontSize: 20 }}>
              لا يمكنك تعديل هذا الإجراء
            </p>
          </div>
        ) : null}

        <div className="d-flex justify-content-around align-items-center my-3 col-10">
          <Button
            containerStyle={"col-4"}
            type={"submit"}
            disable={disable}
            content={
              disable && !errorMessage
                ? Lang.saving
                : errorMessage
                ? "لم يتم الحفظ"
                : Lang.save
            }
            buttonStyleType={"solid"}
          />
          <Button
            content={Lang.cancel}
            containerStyle={"col-4"}
            onClick={() => {
              setVisible(false);
            }}
          />
        </div>
      </div>
    </form>
  );
};

export default EditProcForm;
